











































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'

@Component({
})
export default class Home extends Vue {

	get modules() {
		return this.$store.getters.modules
	}
}
